import { js_utils } from "../utils/frfr-js-utils";


// VALIDATOR UTILS

//
const _da_ili_ne = (da_ne) => {
  // "DA" ili "NE" mora biti odabrano
  if (da_ne === "DA" || da_ne === "NE") {
    return true;
  }
  return false;
};


//
const _subFormArrValidator = (subFormArr, singleFormValidator) => {
  // VALIDATOR FOR ARRAY OF FORMS
  let _validArr = true; // test je inicijalno polozen
  let _errorsArr = [];
  let _subFormArr = [];
  if (Array.isArray(subFormArr)) {
    _subFormArr = subFormArr;
  }
  _errorsArr = _subFormArr.map((subFormState, index) => {
    const [_valid, _errors] = singleFormValidator(subFormState);
    if (_valid !== true) {
      _validArr = false;
    }
    return _errors;
  });
  return [_validArr, _errorsArr];
};


// VALIDATOR LIB
// VALIDATORI

export const validatorNosilacTroska = (formState, cb) => {
  // console.log('Nosilac troska validator');
  // console.log(formState);
  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test

  // svako polje ima jedan test

  if (!formState.nosilactroska || (formState.nosilactroska === '')) {
    valid = false;
    _errors.nosilactroska = 'NTO mora biti unet!';
  }

  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors);
  };

  // Mrzi nas da stalno kucamo pa cemo da stavimo return true dok razvijamo
  // return true;
  return valid;
};


export const validatorComorder = (formState, cb) => {
  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test

  // svako polje ima jedan test

  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors);
  };

  // Mrzi nas da stalno kucamo pa cemo da stavimo return true dok razvijamo
  // return true;
  return valid;
};


export const validatorComorditem = (formState, cb) => {
  let valid = true; // test je inicijalno polozen
  let _errors = {};

  // TODO

  return valid;
};




// klimakomora


export const validatorKlimaKomora = (formState, cb) => {
  // console.log('Klima komora validator');
  // console.log(formState);
  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test

  // svako polje ima jedan test

  if (!formState.sifrakomore || formState.sifrakomore === '') {
    valid = false;
    _errors.sifrakomore = 'Sifra komore mora biti popunjena';
  }
  if (!formState.tipkomore || formState.tipkomore === '') {
    valid = false;
    _errors.tipkomore = 'Tip komore mora biti odabran';
  }

  // Ako je HIGIJENIK onda mora da bude izabrana oplata
  if (formState.tipkomore && formState.tipkomore === 'HYGIENE:pro') {
    if (!formState.unutrasnjaoplata || (formState.unutrasnjaoplata && formState.unutrasnjaoplata === '')) {
      valid = false;
      _errors.unutrasnjaoplata = 'Tip oplate mora biti odabran';
    }
  }

  if (!formState.nazivkomore || formState.nazivkomore === '') {
    valid = false;
    _errors.nazivkomore = 'Naziv komore mora biti unet';
  }
  if (!formState.vrstaprofila || formState.vrstaprofila === '') {
    valid = false;
    _errors.vrstaprofila = 'Vrsta profila mora biti odabrana';
  }

  if (!formState.tipispuneklimakomore || formState.tipispuneklimakomore === '') {
    valid = false;
    _errors.tipispuneklimakomore = 'Tip ispune mora biti odabran';
  }

  if (formState.flag_dimenzijekomoreunc === true) {
    // Proveravamo da li je uneta UNC sirina/visina kad je odabrana UNC
    if (!formState._sirinakomoreunc || formState._sirinakomoreunc === '') {
      valid = false;
      _errors._sirinakomoreunc = 'Unesite sirinu';
    }
    if (!formState._visinakomoreunc || formState._visinakomoreunc === '') {
      valid = false;
      _errors._visinakomoreunc = 'Unesite visinu';
    }
  } else {
    if (!formState._sirinakomoreoznaka || formState._sirinakomoreoznaka === '') {
      valid = false;
      _errors._sirinakomoreoznaka = 'Sirina komore mora biti odabrana';
    }
    if (!formState._visinakomoreoznaka || formState._visinakomoreoznaka === '') {
      valid = false;
      _errors._visinakomoreoznaka = 'Visina komore mora biti odabrana';
    }
  }

  // Proveravamo kad je selektovano da ima 2 velicine
  if (formState.flag_dvevelicine === true) {
    if (formState.flag_dimenzijekomore2unc === true) {
      // Proveravamo da li je uneta UNC sirina 2 kad je odabrana UNC
      if (!formState._sirinakomore2unc || formState._sirinakomore2unc === '') {
        valid = false;
        _errors._sirinakomore2unc = 'Unesite širinu 2';
      }
      if (!formState._visinakomore2unc || formState._visinakomore2unc === '') {
        valid = false;
        _errors._visinakomore2unc = 'Unesite visinu 2';
      }
    } else {
      if (!formState._sirinakomore2oznaka || formState._sirinakomore2oznaka === '') {
        valid = false;
        _errors._sirinakomore2oznaka = 'Druga širina komore mora biti odabrana';
      }
      if (!formState._visinakomore2oznaka || formState._visinakomore2oznaka === '') {
        valid = false;
        _errors._visinakomore2oznaka = 'Druga visina komore mora biti odabrana';
      }
    }
  }

  if (!(js_utils.is_number_greater_than_or_equal_number2(formState.kolicina, 1))) {
    valid = false;
    _errors.kolicina = 'Količina mora biti najmanje 1';
  }


  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors);
  };

  // Mrzi nas da stalno kucamo pa cemo da stavimo return true dok razvijamo
  // return true;
  return valid;
};


// modul

//
export const validatorModul_with_subform = (formState, cb, subFormArr) => {
  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test

  // svako polje ima jedan test

  /*
  if (!formState.siframodula || formState.siframodula === '') {
    valid = false;
    _errors.siframodula = 'Sifra modula mora biti popunjena';
  }
  */

  if (!formState.brojmodula || formState.brojmodula === '') {
    valid = false;
    _errors.brojmodula = 'Broj modula mora biti unet';
  }
  if (formState.brojmodula && formState.brojmodula < 1) {
    valid = false;
    _errors.brojmodula = 'Broj modula mora biti veci od 0';
  }

  if (!formState.duzinamodula || formState.duzinamodula === '') {
    valid = false;
    _errors.duzinamodula = 'Dužina modula mora biti uneta';
  }
  if (formState.duzinamodula && (formState.duzinamodula < 100 || formState.duzinamodula > 7000)) {
    valid = false;
    _errors.duzinamodula = 'Dužina modula mora biti izmedju 100 i 7000';
  }

  // Velicina nije odabrana
  if (!formState.kojavelicina || formState.kojavelicina === '') {
    valid = false;
    _errors.kojavelicina = 'Velicina mora biti odabrana';
  }

  // Da li je uneta CUSTOM dimenzija ako je selektovana custom
  if (formState.kojavelicina === "unc") {
    if (!formState.sirinamodulaunc) {
      valid = false;
      _errors.sirinamodulaunc = 'Custom sirina mora biti uneta';
    }
    if (!formState.visinamodulaunc) {
      valid = false;
      _errors.visinamodulaunc = 'Custom visina mora biti uneta';
    }
  }

  // NOVO VALIDACIJA DINAMICKOG DELA OVE FORME - ARRAYA SUB-FORMI
  const singleFormValidator = _validator_modul_subform_arr;
  let _errors_subform_arr = [];
  const [_validArr, _errorsArr] = _subFormArrValidator(subFormArr, singleFormValidator);
  if (_validArr === false) {
    valid = false;
    _errors_subform_arr = _errorsArr;
  }

  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors, _errors_subform_arr);
  };

  // Mrzi nas da stalno kucamo pa cemo da stavimo return true dok razvijamo
  // return true;
  console.log(valid)
  return valid;
};
//
const _validator_modul_subform_arr = (formState, cb) => {
  // ovo je valdiator samo za dinamicki deo subFormArr...
  // OVAJ VALIDATOR JE CALLBACK I PREDAJE SE KAO DRUGI ARGUMENT FUNKCIJI _subFormArrValidator
  // ON VALIDIRA SVAKU POJEDINACNU FORMU U ARRAY SUB-FORMI
  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test

  /*
  if (!formState.duzinaprofilpregradniunc || formState.duzinaprofilpregradniunc > 0) {
    valid = false;
    _errors.duzinaprofilpregradniunc = 'Dužina mora biti > 0';
  }

  if (!formState.brojkomadaprofilpregradnisirinski || formState.brojkomadaprofilpregradnisirinski > 0) {
    valid = false;
    // _errors.kolicina = 'Broj komada mora biti unet';
    _errors.brojkomadaprofilpregradnisirinski = 'Broj komada mora biti unet' // Nema mesta da bilo sta pise, pa zato ostavljam prazno
  }
  */

  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors);
    console.log('single form validator sending errors by callback');
    console.log(_errors);
  };
  // return valid;
  return [valid, _errors];
};


// ----------validatorPoluproizvod delovi modula
export const validatorPoluproizvod = {};


export const validatorPoluproizvod_panel = {};

validatorPoluproizvod_panel._with_subform = (formState, cb, subFormArr) => {
  // console.log('Demper validator');
  // console.log(formState);
  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test

  // svako polje ima jedan test
  if (!formState.sistempanela || formState.sistempanela === '') {
    valid = false;
    _errors.sistempanela = 'Sistem panela mora biti odabran';
  };

  if (!formState.tipunosapanela || formState.tipunosapanela === '') {
    valid = false;
    _errors.tipunosapanela = 'Tip unosa mora biti odabran';
  };

  // NOVO VALIDACIJA DINAMICKOG DELA OVE FORME - ARRAYA SUB-FORMI
  const singleFormValidator = validatorPoluproizvod_panel._subform_arr;
  let _errors_subform_arr = [];
  const [_validArr, _errorsArr] = _subFormArrValidator(subFormArr, singleFormValidator);
  if (_validArr === false) {
    valid = false;
    _errors_subform_arr = _errorsArr;
  }


  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors, _errors_subform_arr);
    console.log('single form validator sending errors by callback');
    console.log(_errors);
  };
  return valid;
};
//
validatorPoluproizvod_panel._subform_arr = (formState, cb) => {
  // ovo je valdiator samo za dinamicki deo subFormArr...
  // OVAJ VALIDATOR JE CALLBACK I PREDAJE SE KAO DRUGI ARGUMENT FUNKCIJI _subFormArrValidator
  // ON VALIDIRA SVAKU POJEDINACNU FORMU U ARRAY SUB-FORMI
  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test

  if (!formState.tippanela || formState.tippanela === '') {
    valid = false;
    _errors.tippanela = 'Tip panela mora biti odabran';
  } else {
    // ako je odabran tip panela
    if (formState.tippanela === "standardni" || formState.tippanela === "opsluzioni" || formState.tippanela === "vrata") {
      if (!(_da_ili_ne(formState.revizioniotvor))) {
        valid = false;
        _errors.revizioniotvor = 'revizioniotvor mora biti odabran';
      }
    }
    if (formState.tippanela === "vrata") {
      if (!(_da_ili_ne(formState.kljuc))) {
        valid = false;
        _errors.kljuc = 'Kljuc mora biti odabran';
      }
      if (!(_da_ili_ne(formState.sigurnosnabrava))) {
        valid = false;
        _errors.sigurnosnabrava = 'sigurnosnabrava mora biti odabran';
      }
    }
    if (formState.tippanela === "okrugliotvor1" || formState.tippanela === "okrugliotvor2" || formState.tippanela === "panelizmenjivaca") {
      if (!(formState.d1 > 0)) {
        valid = false;
        _errors.d1 = 'D1 mora biti odabran';
      }
      //
      if (formState.tippanela === "okrugliotvor2" || formState.tippanela === "panelizmenjivaca") {
        if (!(formState.d2 > 0)) {
          valid = false;
          _errors.d2 = 'D2 mora biti odabran';
        }
      }
    }
  }

  if (!formState._sirina || formState._sirina < 0) {
    valid = false;
    _errors._sirina = 'Širina mora biti uneta';
    // _errors._sirina = ' ' // Nema mesta da bilo sta pise, pa zato ostavljam prazno
  }

  if (!formState._visina || formState._visina < 0) {
    valid = false;
    _errors._visina = 'Visina mora biti uneta';
    // _errors._visina = ' ' // Nema mesta da bilo sta pise, pa zato ostavljam prazno
  }

  if (!formState.kolicina || formState.kolicina < 0) {
    valid = false;
    // _errors.kolicina = 'Broj komada mora biti unet';
    _errors.kolicina = ' ' // Nema mesta da bilo sta pise, pa zato ostavljam prazno
  }

  // TODO treba dodati i ostale...

  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors);
    console.log('single form validator sending errors by callback');
    console.log(_errors);
  };
  // return valid;
  return [valid, _errors];
};


validatorPoluproizvod.demper = (formState, cb) => {
  // console.log('Demper validator');
  // console.log(formState);
  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test

  // svako polje ima jedan test

  if (!(js_utils.is_number_greater_than_number2(formState.unutrasnjasirina, 100))) {
    valid = false;
    _errors.unutrasnjasirina = 'Unutrasnja sirina mora biti veca od 100mm !';
  }
  if (formState.unutrasnjasirina > 2410) {
    valid = false;
    _errors.unutrasnjasirina = 'Unutrasnja sirina ne moze biti veci od 2410mm!';
  }

  if (!formState.unutrasnjavisina || formState.unutrasnjavisina === '') {
    valid = false;
    _errors.unutrasnjavisina = 'Unutrasnja visina mora biti odabrana';
  }

  // Prema Excelu DEMPER broj krilaca ne moze da bude veci od 12
  // Broj krilaca se vise ne unosi rucno!
  /*
  if (!formState.brojkrilaca || !(formState.brojkrilaca > 0)) {
    valid = false;
    _errors.brojkrilaca = 'Broj krilaca mora biti veci od 0!';
  }
  if (formState.brojkrilaca > 12) {
    valid = false;
    _errors.brojkrilaca = 'Broj krilaca ne moze biti veci od 12!';
  }
  */

  if (!formState.vrstapogona || formState.vrstapogona === '') {
    valid = false;
    _errors.vrstapogona = 'Vrsta pogona mora biti odabrana';
  }

  if (!formState.osovina || formState.osovina === '') {
    valid = false;
    _errors.osovina = 'Osovina mora biti odabrana';
  }

  if (!formState.kolicina || !(formState.kolicina > 0)) {
    valid = false;
    _errors.kolicina = 'Broj komada mora biti veci od 0!';
  }
  if (formState.kolicina > 20) {
    valid = false;
    _errors.kolicina = 'Broj komada ne moze biti veci od 20!';
  }

  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors);
  };
  return valid;
};


validatorPoluproizvod.elasticnaveza = (formState, cb) => {
  // console.log('Elasticna veza validator');
  // console.log(formState);
  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test

  // svako polje ima jedan test
  if (!formState.prirubnica || formState.prirubnica === '') {
    valid = false;
    _errors.prirubnica = 'Prirubnica mora biti odabrana';
  }

  if (!formState.platno || formState.platno === '') {
    valid = false;
    _errors.platno = 'Platno mora biti odabrano';
  }

  if (!(js_utils.is_number_greater_than_number2(formState.sirinaa, 100))) {
    valid = false;
    _errors.sirinaa = 'Sirina A mora biti veca od 100mm !';
  }
  // if (formState.sirinaa > 2450) {
  if (formState.sirinaa > 6000) { // 2024-01-18 DL: Staviti da je dozvoljeno do 6000mm
    valid = false;
    _errors.sirinaa = 'Sirina A ne moze biti veća od 6000mm!';
  }

  if (!(js_utils.is_number_greater_than_number2(formState.visinab, 100))) {
    valid = false;
    _errors.visinab = 'Visina B mora biti veca od 100mm !';
  }
  // if (formState.visinab > 2450) {
  if (formState.visinab > 6000) { // 2024-01-18 NJ: Prepraviti da je dozvoljeno do 6000mm
    valid = false;
    _errors.visinab = 'Visina B ne moze biti veci od 6000mm!';
  }

  if (!formState.kolicina || !(formState.kolicina > 0)) {
    valid = false;
    _errors.kolicina = 'Broj komada mora biti veci od 0!';
  }
  if (formState.kolicina > 20) {
    valid = false;
    _errors.kolicina = 'Broj komada ne moze biti veci od 20!';
  }

  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors);
  };
  return valid;
};


export const validatorPoluproizvod_eliminatorkapi = {};
//
validatorPoluproizvod_eliminatorkapi._with_subform = (formState, cb, subFormArr) => {
  // validatorPoluproizvod.eliminatorKapi = (formState, brojKomadaEliminatoraKapi, cb) => {
  // console.log('Eliminator kapi validator');

  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test
  //
  // svako polje ima jedan test
  //
  let _errors_subform_arr = [];
  const [_validArr, _errorsArr] = _subFormArrValidator(subFormArr, validatorPoluproizvod_eliminatorkapi._subform_arr);
  if (_validArr === false) {
    valid = false;
    _errors_subform_arr = _errorsArr;
  }

  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors, _errors_subform_arr);
  };
  return valid;
};
//
validatorPoluproizvod_eliminatorkapi._subform_arr = (formState, cb) => {
  // ovo je valdiator samo za dinamicki deo subFormArr...
  // OVAJ VALIDATOR JE CALLBACK I PREDAJE SE KAO DRUGI ARGUMENT FUNKCIJI _subFormArrValidator
  // ON VALIDIRA SVAKU POJEDINACNU FORMU U ARRAY SUB-FORMI
  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test

  if (!formState.sirina || formState.sirina < 0) {
    valid = false;
    // _errors.sirina = 'Sirina mora biti uneta';
    _errors.sirina = 'širina mora biti uneta';
  }

  if (!formState.visina || formState.visina < 0) {
    valid = false;
    _errors.visina = 'Visina mora biti uneta';
  }

  if (!(formState.kolicina > 0)) {
    valid = false;
    _errors.kolicina = 'Broj komada mora biti veci od 0!';
  }

  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors);
    console.log('single form validator sending errors by callback');
    console.log(_errors);
  };
  // return valid;
  return [valid, _errors];
};


validatorPoluproizvod.spoljnafiksnazaluzina = (formState, cb) => {
  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test

  // svako polje ima jedan test
  if (!formState.unutrasnjasirina || !(formState.unutrasnjasirina > 0)) {
    valid = false;
    _errors.unutrasnjasirina = 'Unutrašnja širina mora biti uneta';
  }

  if (!formState.unutrasnjavisina || !(formState.unutrasnjavisina > 0)) {
    valid = false;
    _errors.unutrasnjasirina = 'Unutrašnja visina mora biti uneta';
  }

  if (!(formState.kolicina > 0)) {
    valid = false;
    _errors.kolicina = 'Broj komada mora biti veci od 0!';
  }

  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors);
  };
  return valid;
};


// Abecedni deo redosleda Ispod SFZ a iznad postolja


validatorPoluproizvod.kadica = (formState, cb) => {
  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test

  // svako polje ima jedan test
  if (!formState.tip || formState.tip === '') {
    valid = false;
    _errors.tip = 'Tip kadice mora biti odabran';
  }

  if (!formState.sirina || formState.sirina < 0) {
    valid = false;
    // _errors.sirina = 'Sirina mora biti uneta';
    _errors.sirina = 'širina mora biti uneta';
  }

  if (!formState.duzina || formState.duzina < 0) {
    valid = false;
    _errors.duzina = 'Dužina mora biti uneta';
  }

  if (!formState.odvodkondenzata || formState.odvodkondenzata === '') {
    valid = false;
    _errors.odvodkondenzata = 'Odvod kondenzata mora biti odabran';
  }

  if (!(formState.kolicina > 0)) {
    valid = false;
    _errors.kolicina = 'Broj komada mora biti veci od 0!';
  }

  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors);
  };

  return valid;
};


// TODO ** Klizač", "value": "terkk$_bundle_klizac" },
export const validatorPoluproizvod_klizac = {};
//
validatorPoluproizvod_klizac._with_subform = (formState, cb, subFormArr) => {
  // validatorPoluproizvod.eliminatorKapi = (formState, brojKomadaEliminatoraKapi, cb) => {
  // console.log('Eliminator kapi validator');

  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test
  //
  // svako polje ima jedan test

  if (!(js_utils.is_number_zero_or_greater(formState.klizac_brojelemenataiznadpanela))) {
    valid = false;
    _errors.klizac_brojelemenataiznadpanela = 'Broj elemenata mora biti > 0!';
  }
  if (!(js_utils.is_number_zero_or_greater(formState.klizac_brojelemenataiznadkadicestandardna))) {
    valid = false;
    _errors.klizac_brojelemenataiznadkadicestandardna = 'Broj elemenata mora biti > 0!';
  }
  if (formState.klizac_brojelemenataiznadkadicestandardna > 0 && !(formState.klizac_kolikokadicastandardna > 0)) {
    valid = false;
    _errors.klizac_kolikokadicastandardna = 'U ovom slučaju mora biti kadica > 0!';
  }
  if (!(js_utils.is_number_zero_or_greater(formState.klizac_brojelemenataiznadkadiceplitka))) {
    valid = false;
    _errors.klizac_brojelemenataiznadkadiceplitka = 'Broj elemenata mora biti > 0!';
  }
  if (formState.klizac_brojelemenataiznadkadiceplitka > 0 && !(formState.klizac_kolikokadicaplitka > 0)) {
    valid = false;
    _errors.klizac_kolikokadicaplitka = 'U ovom slučaju mora biti kadica > 0!';
  }

  //
  let _errors_subform_arr = [];
  const [_validArr, _errorsArr] = _subFormArrValidator(subFormArr, validatorPoluproizvod_klizac._subform_arr);
  if (_validArr === false) {
    valid = false;
    _errors_subform_arr = _errorsArr;
  }

  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors, _errors_subform_arr);
  };
  return valid;
};
//
validatorPoluproizvod_klizac._subform_arr = (formState, cb) => {
  // ovo je valdiator samo za dinamicki deo subFormArr...
  // OVAJ VALIDATOR JE CALLBACK I PREDAJE SE KAO DRUGI ARGUMENT FUNKCIJI _subFormArrValidator
  // ON VALIDIRA SVAKU POJEDINACNU FORMU U ARRAY SUB-FORMI
  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test

  if (!(formState.kolicina > 0)) {
    valid = false;
    _errors.kolicina = 'Broj komada mora biti veci od 0!';
  }

  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors);
    console.log('single form validator sending errors by callback');
    console.log(_errors);
  };
  // return valid;
  return [valid, _errors];
};


// TODO *** Klizac Rama Mraz Termostata", "value": "terkk$_bundle_klizacramamraztermostata" },


// TODO *** Kuciste Elektro Grejaca


// TODO *** NPR
export const validatorPoluproizvod_npr = {};
validatorPoluproizvod_npr._wiz_step_1 = (formState, cb) => {
  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test

  // svako polje ima jedan test

  if (!formState.npr_tipkomore || (formState.npr_tipkomore === '') || !(formState.npr_tipkomore === "SPRATNA" || formState.npr_tipkomore === "BOK_UZ_BOK")) {
    valid = false;
    _errors.npr_tipkomore = 'SPRATNOST mora biti odabrana!';
  }

  if (!formState.npr_brojmodula || (formState.npr_brojmodula === '') || !(formState.npr_brojmodula === "1" || formState.npr_brojmodula === 1 || formState.npr_brojmodula === "2" || formState.npr_brojmodula === 2)) {
    valid = false;
    _errors.npr_brojmodula = 'Broj modula mora biti odabran!';
  }

  if (!(formState.npr_stranicarekuperatora > 0)) {
    valid = false;
    _errors.npr_stranicarekuperatora = 'Stranica rekuperatora mora biti veći od 0!';
  }

  if (!formState.npr_demperbypass || (formState.npr_demperbypass === '') || !(formState.npr_demperbypass === "DA" || formState.npr_demperbypass === "NE")) {
    valid = false;
    _errors.npr_demperbypass = 'Demper (bypass) mora biti odabran!';
  }
  //
  if (formState.npr_tipkomore === "SPRATNA") {
    if (!(formState.npr_visinadonjesekcije > 0)) {
      valid = false;
      _errors.npr_visinadonjesekcije = 'npr_visinadonjesekcije mora biti veći od 0!';
    }
    if (!(formState.npr_visinagornjesekcije > 0)) {
      valid = false;
      _errors.npr_visinagornjesekcije = 'npr_visinagornjesekcije mora biti veći od 0!';
    }
  } else if (formState.npr_tipkomore === "BOK_UZ_BOK") {
    if (!(formState.npr_sirinaprednjesekcije > 0)) {
      valid = false;
      _errors.npr_sirinaprednjesekcije = 'npr_sirinaprednjesekcije mora biti veći od 0!';
    }
    if (!(formState.npr_sirinazadnjesekcije > 0)) {
      valid = false;
      _errors.npr_sirinazadnjesekcije = 'npr_sirinazadnjesekcije mora biti veći od 0!';
    }
  }

  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors, []);
  };
  return valid;
};
validatorPoluproizvod_npr._wiz_step_2 = (formState, cb) => {
  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test

  // svako polje ima jedan test

  if (!(formState.kolicina > 0)) {
    valid = false;
    _errors.kolicina = 'Broj komada mora biti veći od 0!';
  }

  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors, []);
  };
  return valid;
};


/*
  if (!(js_utils.is_string_not_empty(formState.ramfuk_tipfiltera))) {
    valid = false;
    _errors.ramfuk_tipfiltera = 'Tip filtera mora biti odabran';
  }/////
*/
// TODO *** NRR
export const validatorPoluproizvod_nrr = {};
validatorPoluproizvod_nrr._wiz_step_1 = (formState, cb) => {
  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test

  // svako polje ima jedan test

  if (!(formState.nrr_sirinakomore > 0)) {
    valid = false;
    _errors.nrr_sirinakomore = 'nrr_sirinakomore mora biti veći od 0!';
  }
  if (!(formState.nrr_duzinasekcijespoljasnjamera > 0)) {
    valid = false;
    _errors.nrr_duzinasekcijespoljasnjamera = 'nrr_duzinasekcijespoljasnjamera mora biti veći od 0!';
  }
  if (!(formState.nrr_visinadonjesekcije > 0)) {
    valid = false;
    _errors.nrr_visinadonjesekcije = 'nrr_visinadonjesekcije mora biti veći od 0!';
  }
  if (!(formState.nrr_visinagornjesekcije > 0)) {
    valid = false;
    _errors.nrr_visinagornjesekcije = 'nrr_visinagornjesekcije mora biti veći od 0!';
  }
  if (!(formState.nrr_visinarekuperatora > 0)) {
    valid = false;
    _errors.nrr_visinarekuperatora = 'nrr_visinarekuperatora mora biti veći od 0!';
  }
  if (!(formState.nrr_debljinarekuperatora > 0)) {
    valid = false;
    _errors.nrr_debljinarekuperatora = 'nrr_debljinarekuperatora mora biti veći od 0!';
  }

  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors, []);
  };
  return valid;
};
validatorPoluproizvod_nrr._wiz_step_2 = (formState, cb) => {
  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test

  // svako polje ima jedan test

  if (!(formState.kolicina > 0)) {
    valid = false;
    _errors.kolicina = 'Broj komada mora biti veći od 0!';
  }

  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors, []);
  };
  return valid;
};
// TODO ostali koraci


// TODO *** Nosač ventilatora", "value": "terkk$_bundle_nosacventilatora" },


// TODO  *** PPD (Pregradni panel dempera)", "value": "terkk$_bundle_ppd" },


// PPV

export const validatorPoluproizvod_ppv = {};

// NOSAC
validatorPoluproizvod_ppv._wiz_step_ppvnosacv_1 = (formState, cb) => {
  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test

  // svako polje ima jedan test

  if (!(js_utils.is_string_not_empty(formState.ppv_ventilator_ident))) {
    valid = false;
    _errors.ppv_ventilator_ident = 'Ventilator mora biti odabran';
  }
  /*
  if (!(js_utils.is_string_not_empty(formState.termaterijal))) {
    valid = false;
    _errors.termaterijal = 'Materijal mora biti odabran';
  }
  */
  if (!(formState.ppv_brojventilatora > 0)) {
    valid = false;
    _errors.ppv_brojventilatora = 'Koliko ventilatora mora biti > 0';
  }
  if (!(js_utils.is_string_not_empty(formState.ppvnosacv_smermontaze))) {
    valid = false;
    _errors.ppvnosacv_smermontaze = 'Smer montaže mora biti odabran';
  }
  if (!(js_utils.is_string_not_empty(formState.ppv_isnapregradnom))) {
    valid = false;
    _errors.ppv_isnapregradnom = 'Na pregradnom mora biti odabran';
  }
  if (!(js_utils.is_string_not_empty(formState.ppvnosacv_pregradniprofil))) {
    valid = false;
    _errors.ppvnosacv_pregradniprofil = 'Pregradni profil mora biti odabran';
  }
  /*
  if (!(formState.kolicina > 0)) {
    valid = false;
    _errors.kolicina = 'Broj komada mora biti veći od 0!';
  }
  */

  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors, []);
  };
  return valid;
};
validatorPoluproizvod_ppv._wiz_step_ppvnosacv_2 = (formState, cb) => {
  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test

  // svako polje ima jedan test

  if (!(js_utils.is_number_zero_or_greater(formState.ppvnosacv_precnikotvora))) {
    valid = false;
    _errors.ppvnosacv_precnikotvora = 'Prečnik otvora mora biti broj';
  }
  if (!(formState.ppvnosacv_duzinanosacal > 0)) {
    valid = false;
    _errors.ppvnosacv_duzinanosacal = 'Dužina nosača L mora biti > 0';
  }
  if (!(js_utils.is_number_zero_or_greater(formState.ppvnosacv_l1))) {
    valid = false;
    _errors.ppvnosacv_l1 = 'L1 mora biti broj';
  }
  if (!(js_utils.is_number_zero_or_greater(formState.ppvnosacv_l2))) {
    valid = false;
    _errors.ppvnosacv_l2 = 'L2 mora biti broj';
  }
  if (!(js_utils.is_number_zero_or_greater(formState.ppvnosacv_l3))) {
    valid = false;
    _errors.ppvnosacv_l3 = 'L3 mora biti broj';
  }
  if (!(formState.kolicina > 0)) {
    valid = false;
    _errors.kolicina = 'Broj komada mora biti veći od 0!';
  }

  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors, []);
  };
  return valid;
};
validatorPoluproizvod_ppv._wiz_step_ppvnosacv_3 = (formState, cb) => {
  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test

  // svako polje ima jedan test

  if (!(formState.ppvnosac_tip === "A" || formState.ppvnosac_tip === "B")) {
    valid = false;
    _errors.ppvnosac_tip = 'Morate odabrati tip';
  }

  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors, []);
  };
  return valid;
};

// PPV samo

validatorPoluproizvod_ppv._wiz_step_1 = (formState, cb) => {
  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test

  // svako polje ima jedan test

  if (!(js_utils.is_string_not_empty(formState.ppv_ventilator_ident))) {
    valid = false;
    _errors.ppv_ventilator_ident = 'Ventilator mora biti odabran';
  }
  if (!(js_utils.is_number_zero_or_greater(formState.ppv_o1))) {
    valid = false;
    _errors.ppv_o1 = 'O1 mora biti broj';
  }
  if (!(js_utils.is_number_zero_or_greater(formState.ppv_o2))) {
    valid = false;
    _errors.ppv_o2 = 'O2 mora biti broj';
  }
  if (!(js_utils.is_number_zero_or_greater(formState.ppv_o1))) {
    valid = false;
    _errors.ppv_o1zazor = 'Zazor O1 mora biti broj';
  }

  // preseljeno iz ppv_wiz_step_2_ex

  if (!(js_utils.is_number_zero_or_greater(formState.ppv_brojventilatora))) {
    valid = false;
    _errors.ppv_brojventilatora = 'Koliko ventilatora mora biti > 0';
  }
  // if (!(js_utils.is_string_not_empty(formState.ppv_kolikokolona))) {
  if (!(js_utils.is_number_zero_or_greater(formState.ppv_kolikokolona))) {
    valid = false;
    _errors.ppv_kolikokolona = 'Morate odabrati broj kolona';
  }
  if (!(js_utils.is_number_zero_or_greater(formState.ppv_kolikoredova))) {
    valid = false;
    _errors.ppv_kolikoredova = 'Koliko redova mora biti > 0';
  }
  if (!(js_utils.is_number_zero_or_greater(formState.ppv_kolikosekcija))) {
    valid = false;
    _errors.ppv_kolikosekcija = 'Koliko sekcija mora biti > 0';
  }

  if (!(_da_ili_ne(formState.ppv_isnapregradnom))) {
    valid = false;
    _errors.ppv_isnapregradnom = 'Na pregradnom mora biti odabrano';
  }

  if (!(js_utils.is_number_zero_or_greater(formState.ppv_b))) {
    valid = false;
    _errors.ppv_b = 'Širina mora biti broj';
  }
  if (!(js_utils.is_number_zero_or_greater(formState.ppv_h))) {
    valid = false;
    _errors.ppv_h = 'Visina mora biti broj';
  }
  if (!(js_utils.is_number_zero_or_greater(formState.ppv_sirinaojacanja))) {
    valid = false;
    _errors.ppv_sirinaojacanja = 'Širina ojačanja mora biti broj';
  }

  if (!(formState.kolicina > 0)) {
    valid = false;
    _errors.kolicina = 'Broj komada mora biti veći od 0!';
  }

  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors, []);
  };
  return valid;
};

validatorPoluproizvod_ppv._wiz_step_2 = (formState, cb) => {
  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test

  // svako polje ima jedan test

  // TODO

  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors, []);
  };
  return valid;
};

validatorPoluproizvod_ppv._wiz_step_3 = (formState, cb) => {
  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test

  // svako polje ima jedan test

  if (!(formState.ppv_tip === "1D" || formState.ppv_tip === "4D" || formState.ppv_tip === "6D")) {
    valid = false;
    _errors.ppv_tip = 'Morate odabrati tip ppv';
  }
  if (!(formState.ppv_tip_preporuceni === "1D" || formState.ppv_tip_preporuceni === "4D" || formState.ppv_tip_preporuceni === "6D")) {
    valid = false;
    _errors.ppv_tip_preporuceni = 'Neispravan tip ppv';
  }

  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors, []);
  };
  return valid;
};

validatorPoluproizvod_ppv._with_subform = (formState, cb, subFormArr) => {
  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test

  // svako polje ima jedan test

  let _errors_subform_arr = [];
  const [_validArr, _errorsArr] = _subFormArrValidator(subFormArr, validatorPoluproizvod_ppv._subform_arr);
  if (_validArr === false) {
    valid = false;
    _errors_subform_arr = _errorsArr;
  }

  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors, _errors_subform_arr);
  };
  return valid;
};

validatorPoluproizvod_ppv._subform_arr = (formState, cb) => {
  // ovo je valdiator samo za dinamicki deo subFormArr...
  // OVAJ VALIDATOR JE CALLBACK I PREDAJE SE KAO DRUGI ARGUMENT FUNKCIJI _subFormArrValidator
  // ON VALIDIRA SVAKU POJEDINACNU FORMU U ARRAY SUB-FORMI
  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test



  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors);
    console.log('single form validator sending errors by callback');
    console.log(_errors);
  };
  // return valid;
  return [valid, _errors];
};


//
export const validatorPoluproizvod_prigusivacbuke = {};
//
validatorPoluproizvod_prigusivacbuke._with_subform = (formState, cb, subFormArr) => {
  // validatorPoluproizvod.eliminatorKapi = (formState, brojKomadaEliminatoraKapi, cb) => {
  // console.log('Eliminator kapi validator');

  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test
  //
  // svako polje ima jedan test

  if (!(formState.prb_sirinakulisa > 0)) {
    valid = false;
    _errors.prb_sirinakulisa = 'prb_sirinakulisa mora biti odabran';
  }
  if (!(formState.prb_rastojanjeizmedjukulisa > 0)) {
    valid = false;
    _errors.prb_rastojanjeizmedjukulisa = 'prb_rastojanjeizmedjukulisa mora biti > 0';
  }
  if (!(formState.prb_visinakulisa > 0)) {
    valid = false;
    _errors.prb_visinakulisa = 'prb_visinakulisa mora biti > 0';
  }
  if (!(formState.prb_duzinakulisa > 0)) {
    valid = false;
    _errors.prb_duzinakulisa = 'prb_duzinakulisa mora biti > 0';
  }

  if (!(js_utils.is_number_zero_or_greater(formState.prb_kolicinaprigusivaca))) {
    valid = false;
    _errors.prb_kolicinaprigusivaca = 'prb_kolicinaprigusivaca mora biti broj';
  }
  /*
  if (!(js_utils.is_number_zero_or_greater(formState.prb_kolikokulisauprigusivacu))) {
    valid = false;
    _errors.prb_kolikokulisauprigusivacu = 'prb_kolikokulisauprigusivacu mora biti broj';
  }
  */

  //
  let _errors_subform_arr = [];
  const [_validArr, _errorsArr] = _subFormArrValidator(subFormArr, validatorPoluproizvod_prigusivacbuke._subform_arr);
  if (_validArr === false) {
    valid = false;
    _errors_subform_arr = _errorsArr;
  }

  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors, _errors_subform_arr);
  };
  return valid;
};
//
validatorPoluproizvod_prigusivacbuke._subform_arr = (formState, cb) => {
  // ovo je valdiator samo za dinamicki deo subFormArr...
  // OVAJ VALIDATOR JE CALLBACK I PREDAJE SE KAO DRUGI ARGUMENT FUNKCIJI _subFormArrValidator
  // ON VALIDIRA SVAKU POJEDINACNU FORMU U ARRAY SUB-FORMI
  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test

  if (!(formState.kolicina > 0)) {
    valid = false;
    _errors.kolicina = 'Broj komada mora biti veci od 0!';
  }

  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors);
    console.log('single form validator sending errors by callback');
    console.log(_errors);
  };
  // return valid;
  return [valid, _errors];
};


// TODO *** Ram Filtera Na Uklizavanje", "value": "terkk$_bundle_ramfilteranauklizavanje" },
export const validatorPoluproizvod_ramfilteranauklizavanje = {};
validatorPoluproizvod_ramfilteranauklizavanje._wiz_step_1 = (formState, cb) => {
  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test

  // svako polje ima jedan test

  if (!(js_utils.is_string_not_empty(formState.ramfuk_tipfiltera))) {
    valid = false;
    _errors.ramfuk_tipfiltera = 'Tip filtera mora biti odabran';
  }
  if (!(formState.kolicina > 0)) {
    valid = false;
    _errors.kolicina = 'Broj komada mora biti veći od 0!';
  }

  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors, []);
  };
  return valid;
};


// RMT ramamraztermotstata TODO ???
export const validatorPoluproizvod_rammraztermostata = {};
validatorPoluproizvod_rammraztermostata._wiz_step_1 = (formState, cb) => {
  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test

  // svako polje ima jedan test

  if (!(formState.kolicina > 0)) {
    valid = false;
    _errors.kolicina = 'Broj komada mora biti veći od 0!';
  }

  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors, []);
  };
  return valid;
};


// Zadnji deo redosleda pocinje od postolja.


// postolje
export const validatorPoluproizvod_postolje = {};
//
validatorPoluproizvod_postolje._with_subform = (formState, cb, subFormArr) => {
  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test

  // svako polje ima jedan test
  if (!formState.sirinapostolja || formState.sirinapostolja < 0) {
    valid = false;
    // _errors.sirina = 'Sirina mora biti uneta';
    _errors.sirinapostolja = 'širina mora biti uneta';
  }

  if (!formState.duzinapostolja || formState.duzinapostolja < 0) {
    valid = false;
    _errors.duzinapostolja = 'Dužina mora biti uneta';
  }

  if (!formState.visinapostolja || formState.visinapostolja < 0) {
    valid = false;
    _errors.visinapostolja = 'Visina mora biti uneta';
  }

  if (!formState.smerojacanjapostolja || (formState.smerojacanjapostolja === '') || !(formState.smerojacanjapostolja === "PODUZINI" || formState.smerojacanjapostolja === "POSIRINI")) {
    valid = false;
    _errors.smerojacanjapostolja = 'Smer ojačanja postolja mere mora biti odabran!';
  }

  let _errors_subform_arr = [];
  const [_validArr, _errorsArr] = _subFormArrValidator(subFormArr, validatorPoluproizvod_postolje._subform_arr);
  if (_validArr === false) {
    valid = false;
    _errors_subform_arr = _errorsArr;
  }

  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors, _errors_subform_arr);
  };
  return valid;
};
//
validatorPoluproizvod_postolje._subform_arr = (formState, cb) => {
  // ovo je valdiator samo za dinamicki deo subFormArr...
  // OVAJ VALIDATOR JE CALLBACK I PREDAJE SE KAO DRUGI ARGUMENT FUNKCIJI _subFormArrValidator
  // ON VALIDIRA SVAKU POJEDINACNU FORMU U ARRAY SUB-FORMI
  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test

  if (!formState.tip || (formState.tip === '')) {
    valid = false;
    _errors.tip = 'Tip mora biti odabran!';
  }

  if (!formState.duzina || formState.duzina < 0) {
    valid = false;
    _errors.duzina = 'Dužina mora biti uneta';
  }

  if (!(formState.kolicina > 0)) {
    valid = false;
    _errors.kolicina = 'Broj komada mora biti veci od 0!';
  }

  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors);
    console.log('single form validator sending errors by callback');
    console.log(_errors);
  };
  // return valid;
  return [valid, _errors];
};
//
validatorPoluproizvod_postolje._wiz_step_1 = (formState, cb) => {
  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test

  // svako polje ima jedan test
  if (!formState.sirinapostolja || formState.sirinapostolja < 0) {
    valid = false;
    // _errors.sirina = 'Sirina mora biti uneta';
    _errors.sirinapostolja = 'širina mora biti uneta';
  }

  if (!formState.duzinapostolja || formState.duzinapostolja < 0) {
    valid = false;
    _errors.duzinapostolja = 'Dužina mora biti uneta';
  }

  if (!formState.visinapostolja || formState.visinapostolja < 0) {
    valid = false;
    _errors.visinapostolja = 'Visina mora biti uneta';
  }

  if (!formState.smerojacanjapostolja || (formState.smerojacanjapostolja === '') || !(formState.smerojacanjapostolja === "PODUZINI" || formState.smerojacanjapostolja === "POSIRINI")) {
    valid = false;
    _errors.smerojacanjapostolja = 'Smer ojačanja postolja mere mora biti odabran!';
  }

  if (!(formState.kolicina > 0)) {
    valid = false;
    _errors.kolicina = 'Broj komada mora biti veći od 0!';
  }

  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors, []);
  };
  return valid;
};




// krov
export const validatorPoluproizvod_krov = {};
//
validatorPoluproizvod_krov._with_subform = (formState, cb, subFormArr) => {
  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test

  // svako polje ima jedan test

  let _errors_subform_arr = [];
  const [_validArr, _errorsArr] = _subFormArrValidator(subFormArr, validatorPoluproizvod_krov._subform_arr);
  if (_validArr === false) {
    valid = false;
    _errors_subform_arr = _errorsArr;
  }

  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors, _errors_subform_arr);
  };
  return valid;
};
//
validatorPoluproizvod_krov._subform_arr = (formState, cb) => {
  // ovo je valdiator samo za dinamicki deo subFormArr...
  // OVAJ VALIDATOR JE CALLBACK I PREDAJE SE KAO DRUGI ARGUMENT FUNKCIJI _subFormArrValidator
  // ON VALIDIRA SVAKU POJEDINACNU FORMU U ARRAY SUB-FORMI
  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test

  if (!(formState.tipkrovnogsegmenta && typeof formState.tipkrovnogsegmenta === 'string' && formState.tipkrovnogsegmenta !== '')) {
    valid = false;
    _errors.tipkrovnogsegmenta = 'Tip mora biti odabran';
  }

  if (!(js_utils.is_number_greater_than_or_equal_number2(formState.duzina, 1))) {
    valid = false;
    _errors.duzina = 'Dužina mora biti najmanje 1mm!';
  }

  if (!(js_utils.is_number_zero_or_greater(formState.povrsina))) {
    valid = false;
    _errors.povrsina = 'Površina mora biti broj';
  }

  if (!(js_utils.is_number_greater_than_or_equal_number2(formState.kolicina, 1))) {
    valid = false;
    _errors.kolicina = 'Količina mora biti najmanje 1';
  }

  // console.log('VALIDATOR KROV formState', formState);
  // console.log('krovniotvor', formState.krovniotvor, typeof formState.krovniotvor);
  console.log('formState.krovniotvor === "DA"', formState.krovniotvor === "DA");
  if (formState.tipkrovnogsegmenta !== "KROVNA_SNALA") {
    // za sve osim tipa KROVNA SNALA
    console.log('validator - nije KROVNA SNALA');

    if (!(js_utils.is_number_greater_than_or_equal_number2(formState.sirina, 1))) {
      valid = false;
      _errors.sirina = 'Širina mora biti najmanje 1mm!';
    }

    if (!(_da_ili_ne(formState.krovniotvor))) {
      valid = false;
      _errors.krovniotvor = 'Otvor mora biti odabran';
    }
    //
    // console.log('formState.krovniotvor', formState.krovniotvor, formState.krovniotvor === "DA");
    if (formState.krovniotvor === "DA") {
      console.log('TEST krovniotvor DA', formState.a, formState.a >= 0, !(formState.a >= 0), js_utils.is_number_zero_or_greater(formState.a)); // TEST
      if (!(js_utils.is_number_zero_or_greater(formState.a))) {
        valid = false;
        _errors.a = 'a mora biti uneto';
      }
      if (!(js_utils.is_number_zero_or_greater(formState.b))) {
        valid = false;
        _errors.b = 'b mora biti uneto';
      }
      if (!(js_utils.is_number_zero_or_greater(formState.x))) {
        valid = false;
        _errors.x = 'x mora biti uneto';
      }
      if (!(js_utils.is_number_zero_or_greater(formState.y))) {
        valid = false;
        _errors.y = 'y mora biti uneto';
      }
    }
  }

  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors);
    console.log('single form validator sending errors by callback');
    console.log(_errors);
  };
  // return valid;
  return [valid, _errors];
};


// Zadnja je paleta


// zatim idu CUSTOM poluproizvodi

export const _validator_profilcustom_subform_arr = (formState, cb) => {
  // ovo je valdiator samo za dinamicki deo subFormArr...
  // OVAJ VALIDATOR JE CALLBACK I PREDAJE SE KAO DRUGI ARGUMENT FUNKCIJI _subFormArrValidator
  // ON VALIDIRA SVAKU POJEDINACNU FORMU U ARRAY SUB-FORMI
  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test

  if (!formState.identmaterijala || formState.identmaterijala === '') {
    valid = false;
    _errors.identmaterijala = 'Ident mora biti unet';
  }
  if (!formState.naziv || formState.naziv === '') {
    valid = false;
    _errors.naziv = 'Naziv mora biti unet';
  }

  if (!(formState.duzina > 0)) {
    valid = false;
    _errors.duzina = 'Dužina mora biti veća od 0';
  }

  if (!(js_utils.is_number(formState.leviger) && formState.leviger >= 0 && formState.leviger <= 90)) {
    valid = false;
    _errors.leviger = 'Ger može biti od 0 do 90';
  }
  if (!(js_utils.is_number(formState.desniger) && formState.desniger >= 0 && formState.desniger <= 90)) {
    valid = false;
    _errors.desniger = 'Ger može biti od 0 do 90';
  }

  if (!(js_utils.is_number_greater_than_or_equal_number2(formState.kolicina, 1))) {
    valid = false;
    _errors.kolicina = 'Količina mora biti najmanje 1';
  }

  if (!formState.operacija || formState.operacija === '') {
    valid = false;
    _errors.operacija = 'Operacija mora biti odabrana/popunjena';
  }
  if (!formState.rc || formState.rc === '') {
    valid = false;
    _errors.rc = 'Radni centar mora biti odabran/popunjen';
  }

  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors);
    console.log('single form validator sending errors by callback');
    console.log(_errors);
  };
  // return valid;
  return [valid, _errors];
};
//
export const _validator_limcustom_subform_arr = (formState, cb) => {
  // ovo je valdiator samo za dinamicki deo subFormArr...
  // OVAJ VALIDATOR JE CALLBACK I PREDAJE SE KAO DRUGI ARGUMENT FUNKCIJI _subFormArrValidator
  // ON VALIDIRA SVAKU POJEDINACNU FORMU U ARRAY SUB-FORMI
  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test

  if (!formState.identmaterijala || formState.identmaterijala === '') {
    valid = false;
    _errors.identmaterijala = 'Ident mora biti unet';
  }
  if (!formState.naziv || formState.naziv === '') {
    valid = false;
    _errors.naziv = 'Naziv mora biti unet';
  }

  if (!(js_utils.is_number_zero_or_greater(formState.povrsina))) {
    valid = false;
    _errors.povrsina = 'Površina mora biti broj';
  }

  if (!(js_utils.is_number_greater_than_or_equal_number2(formState.kolicina, 1))) {
    valid = false;
    _errors.kolicina = 'Količina mora biti najmanje 1';
  }

  if (!formState.operacija1 || formState.operacija1 === '') {
    valid = false;
    _errors.operacija1 = 'Operacija mora biti odabrana/popunjena';
  }
  if (!formState.rc1 || formState.rc1 === '') {
    valid = false;
    _errors.rc1 = 'Radni centar mora biti odabran/popunjen';
  }

  if (typeof formState.rc1 === 'string' && formState.rc1 !== '' && formState.rc1 !== "RCLINS4P4") {
    if (!formState.operacija2 || formState.operacija2 === '') {
      /*
      valid = false;
      _errors.operacija2 = 'Operacija mora biti odabrana/popunjena';
      */
    } else {
      if (!formState.rc2 || formState.rc2 === '') {
        valid = false;
        _errors.rc2 = 'Radni centar mora biti odabran/popunjen';
      }
    }
  }

  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors);
    console.log('single form validator sending errors by callback');
    console.log(_errors);
  };
  // return valid;
  return [valid, _errors];
};


export const validator_profilcustom_with_subform = (formState, cb, subFormArr) => {
  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test
  //
  // svako polje ima jedan test
  //
  let _errors_subform_arr = [];
  const [_validArr, _errorsArr] = _subFormArrValidator(subFormArr, _validator_profilcustom_subform_arr);
  if (_validArr === false) {
    valid = false;
    _errors_subform_arr = _errorsArr;
  }
  //
  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors, _errors_subform_arr);
  };
  return valid;
};
//
export const validator_limcustom_with_subform = (formState, cb, subFormArr) => {
  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test
  //
  // svako polje ima jedan test
  //
  let _errors_subform_arr = [];
  const [_validArr, _errorsArr] = _subFormArrValidator(subFormArr, _validator_limcustom_subform_arr);
  if (_validArr === false) {
    valid = false;
    _errors_subform_arr = _errorsArr;
  }
  //
  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors, _errors_subform_arr);
  };
  return valid;
};


// posle poluproizvoda idu materijali

export const validatorMaterijalCustom = (formState, cb) => {
  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test

  // svako polje ima jedan test

  // if (!formState.identcustom || (formState.identcustom === '')) {
  if (!(js_utils.is_string_not_empty(formState.identcustom))) {
    valid = false;
    _errors.identcustom = 'Ident mora biti unet!';
  } else {
    if (formState.identcustom.trim() !== formState.identcustom) {
      valid = false;
      _errors.identcustom = 'Proveri razmake na početku i na kraju!';
    }
  }

  if (!formState.kolicina || !(formState.kolicina > 0)) {
    valid = false;
    _errors.kolicina = 'Količina mora biti uneta!';
  }

  if (!formState.jm || (formState.jm === '')) {
    valid = false;
    _errors.jm = 'Jedinica mere mora biti odabrana!';
  }

  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors);
  };

  // Mrzi nas da stalno kucamo pa cemo da stavimo return true dok razvijamo
  // return true;
  return valid;
};
export const validatorMaterijalCustom_subform_arr = (formState, cb) => {
  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test

  // svako polje ima jedan test

  if (!formState.identcustom || (formState.identcustom === '')) {
    valid = false;
    _errors.identcustom = 'Ident mora biti unet!';
  }

  if (!formState.kolicina || !(formState.kolicina > 0)) {
    valid = false;
    _errors.kolicina = 'Količina mora biti uneta!';
  }

  if (!formState.jm || (formState.jm === '')) {
    valid = false;
    _errors.jm = 'Jedinica mere mora biti odabrana!';
  }

  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors);
  };

  // Mrzi nas da stalno kucamo pa cemo da stavimo return true dok razvijamo
  // return true;
  // return valid;
  return [valid, _errors];
};
//
export const validatorMaterijalCustom_bulk = (formState, cb, subFormArr) => {
  // validatorPoluproizvod.eliminatorKapi = (formState, brojKomadaEliminatoraKapi, cb) => {
  // console.log('Eliminator kapi validator');

  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test
  //
  // svako polje ima jedan test
  //
  let _errors_subform_arr = [];
  const [_validArr, _errorsArr] = _subFormArrValidator(subFormArr, validatorMaterijalCustom_subform_arr);
  if (_validArr === false) {
    valid = false;
    _errors_subform_arr = _errorsArr;
  }

  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors, _errors_subform_arr);
  };
  return valid;
};


// REZERVA


export const novi_validator_without_subform = (formState, cb) => {
  // console.log('Demper validator');
  // console.log(formState);
  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test
  //
  // svako polje ima jedan test
  //
  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors);
  };
  return valid;
};


export const novi_validator_with_subform = (formState, cb, subFormArr) => {
  // validatorPoluproizvod.eliminatorKapi = (formState, brojKomadaEliminatoraKapi, cb) => {
  // console.log('Eliminator kapi validator');
  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test
  //
  // svako polje ima jedan test
  //
  let _errors_subform_arr = [];
  const [_validArr, _errorsArr] = _subFormArrValidator(subFormArr, novi_validator_subform_arr);
  if (_validArr === false) {
    valid = false;
    _errors_subform_arr = _errorsArr;
  }

  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors, _errors_subform_arr);
  };
  return valid;
};
//
const novi_validator_subform_arr = (formState, cb) => {
  // ovo je valdiator samo za dinamicki deo subFormArr...
  // OVAJ VALIDATOR JE CALLBACK I PREDAJE SE KAO DRUGI ARGUMENT FUNKCIJI _subFormArrValidator
  // ON VALIDIRA SVAKU POJEDINACNU FORMU U ARRAY SUB-FORMI
  let valid = true; // test je inicijalno polozen
  let _errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test

  if (!(formState.kolicina > 0)) {
    valid = false;
    _errors.kolicina = 'Broj komada mora biti veci od 0!';
  }

  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(_errors);
    console.log('single form validator sending errors by callback');
    console.log(_errors);
  };
  // return valid;
  return [valid, _errors];
};

